<template>
  <div class="flex justify-center items-center">
    <div
      style="border-top-color: transparent"
      class="
        w-16
        h-16
        border-4 border-blue-500 border-solid
        rounded-full
        animate-spin
      "
    ></div>
  </div>
</template>
